import React, { useEffect, useState } from 'react';
import '../styles/ScrollIndicator.scss';


export default function ScrollIndicator() {
    const [pct, setPct] = useState(0);
    useEffect(() => {
        const onScroll = () => {
            const s = window.scrollY;
            const h = document.body.scrollHeight - window.innerHeight;
            setPct(h > 0 ? Math.round((s / h) * 100) : 0);
        };
        window.addEventListener('scroll', onScroll);
        onScroll();
        return () => window.removeEventListener('scroll', onScroll);
    }, []);


    return (
        <div className="scroll-indicator" aria-hidden>
            <div className="bar" style={{ width: `${pct}%` }} />
        </div>
    );
}